import { ListadoModalBalanceOtrosProductosDto } from "./ListadoModalBalanceOtrosProductosDto";

export class ModalBalanceOtrosProductosDto {

  gedomFacturas?: number;
  gedomRecargas?: number;
  proveedorFacturas?: number;
  proveedorRecargas?: number;
  totalEmpresasFacturas?: number;
  totalEmpresasRecargas?: number;
  data?: ListadoModalBalanceOtrosProductosDto[] = [];

  constructor(init?: Partial<ModalBalanceOtrosProductosDto>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}